/* irh-hub.js: the recipe hub on /blogs/all-new-recipes (and the old category blogs) (2026-10-13).
   The page arrives with the first recipes already in the HTML (for Google and for slow phones). This file
   then loads the whole library once and takes over: instant search, filters, lanes, the kitchen matcher,
   cook-by-spice and saved recipes. If the library cannot load, the HTML grid and its page links stay. */
(function () {
  'use strict';
  var root = document.querySelector('[data-irh-hub]');
  if (!root || !window.IRH) return;
  var X = window.IRH, esc = X.esc, icon = X.icon;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };

  var FEED = root.getAttribute('data-feed') || '/blogs/all-new-recipes';
  var PRESET = {}; try { PRESET = JSON.parse(root.getAttribute('data-preset') || '{}'); } catch (e) { console.warn('irh: preset', e); }
  var PAGE = 24;

  var ALL = [], BY = {};
  var S = { mode: 'browse', q: '', meal: [], cui: [], main: [], life: [], time: '', sort: 'best', spice: '', have: [], staples: true, region: 'all', shown: PAGE };

  /* ---------------- state <-> URL (shareable, back button works) ---------------- */
  var LISTS = ['meal', 'cui', 'main', 'life', 'have'];
  function readURL() {
    var p = new URLSearchParams(location.search), any = false;
    ['q', 'time', 'sort', 'spice', 'mode'].forEach(function (k) { if (p.get(k)) { S[k] = p.get(k); any = true; } });
    LISTS.forEach(function (k) { if (p.get(k)) { S[k] = p.get(k).split(',').filter(Boolean); any = true; } });
    if (!any && PRESET) LISTS.concat(['time']).forEach(function (k) { if (PRESET[k]) S[k] = PRESET[k]; });
  }
  function writeURL() {
    var p = new URLSearchParams(location.search);
    ['q', 'time', 'spice'].forEach(function (k) { if (S[k]) p.set(k, S[k]); else p.delete(k); });
    if (S.sort !== 'best') p.set('sort', S.sort); else p.delete('sort');
    if (S.mode !== 'browse') p.set('mode', S.mode); else p.delete('mode');
    LISTS.forEach(function (k) { if (S[k].length) p.set(k, S[k].join(',')); else p.delete(k); });
    p.delete('page');
    var qs = p.toString();
    history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  }

  /* ---------------- filtering ---------------- */
  function timeOk(r, t) {
    if (!t) return true;
    if (r.total == null) return false;
    if (t === 'slow') return r.total >= 180;
    return r.total <= parseInt(t, 10);
  }
  function passes(r, except) {
    for (var i = 0; i < 4; i++) {
      var g = ['meal', 'cui', 'main', 'life'][i];
      if (g === except || !S[g].length) continue;
      if (!S[g].some(function (k) { return r[g].indexOf(k) > -1; })) return false;
    }
    if (except !== 'time' && !timeOk(r, S.time)) return false;
    if (S.spice && !r.x.some(function (p) { return p.h === S.spice; })) return false;
    return true;
  }
  var lastSearch = null;
  function results() {
    var base = ALL;
    if (S.mode === 'saved') { var sv = X.saved.all(); base = sv.map(function (h) { return BY[h]; }).filter(Boolean); }
    var s = X.search(base, S.q); lastSearch = s;
    var list = s.list.filter(function (r) { return passes(r); });
    if (S.mode === 'kitchen') list = kitchen(list);
    else sortList(list, s.scores);
    return list;
  }
  function sortList(list, scores) {
    var k = S.sort;
    if (k === 'best' && scores) return;   /* search order already ranks by match */
    if (k === 'fast') list.sort(function (a, b) { return (a.total == null ? 1e6 : a.total) - (b.total == null ? 1e6 : b.total); });
    else if (k === 'few') list.sort(function (a, b) { return (a.ing.length || 99) - (b.ing.length || 99); });
    else if (k === 'az') list.sort(function (a, b) { return a.t.localeCompare(b.t); });
    else if (k === 'best') list.sort(function (a, b) { return quality(b) - quality(a); });
    /* 'new' = the feed order (newest first) */
  }
  /* "best" without a search: complete recipes first, so the top of the page is never a half-filled card */
  function quality(r) { return (r.i ? 3 : 0) + (r.total != null ? 2 : 0) + (r.ing.length ? 2 : 0) + (r.x.length ? 2 : 0) + (r.video ? 1 : 0); }

  /* ---------------- kitchen: cook with what you have ---------------- */
  /* which of your ingredients this line is (index), or -1 */
  var BROTH = /\b(broth|stock|bouillon)\b/;
  function haveHit(name, chips) {
    var ws = X.words(name);
    var broth = BROTH.test(name);
    for (var i = 0; i < chips.length; i++) {
      var cs = X.words(chips[i]).map(X.stem);
      if (broth && !BROTH.test(chips[i])) continue;   /* "chicken broth" is not chicken */
      if (cs.length && cs.every(function (cw) { return ws.some(function (w) { var sw = X.stem(w); return sw === cw || (cw.length >= 4 && sw.indexOf(cw) === 0); }); })) return i;
    }
    return -1;
  }
  function kitchen(list) {
    if (!S.have.length) return [];
    var out = [];
    list.forEach(function (r) {
      if (!r.names.length) return;
      var have = 0, chips = {}, missing = [];
      r.names.forEach(function (n) {
        if (!n || X.SPICE_LINE.test(n)) return;   /* spices are not "what's in your fridge" */
        var k = haveHit(n, S.have);
        if (k > -1) { have++; chips[k] = 1; }
        else if (S.staples && X.STAPLE.test(n)) have++;
        else { var sn = X.shortName(n); if (sn && missing.indexOf(sn) < 0) missing.push(sn); }
      });
      var used = Object.keys(chips).length;
      if (!used) return;
      r._k = { have: have, total: have + missing.length, missing: missing, used: used };
      out.push(r);
    });
    /* recipes that use more of what you typed first, then the fewest things to buy */
    out.sort(function (a, b) { return (b._k.used - a._k.used) || (a._k.missing.length - b._k.missing.length) || (b._k.have / b._k.total - a._k.have / a._k.total); });
    return out;
  }

  /* ---------------- counts for every option, given the other filters ---------------- */
  function counts(group) {
    var c = {}, base = X.search(S.mode === 'saved' ? X.saved.all().map(function (h) { return BY[h]; }).filter(Boolean) : ALL, S.q).list;
    base.forEach(function (r) {
      if (!passes(r, group)) return;
      if (group === 'time') {
        X.TIME.forEach(function (t) { if (timeOk(r, t[0])) c[t[0]] = (c[t[0]] || 0) + 1; });
      } else r[group].forEach(function (k) { c[k] = (c[k] || 0) + 1; });
    });
    return c;
  }

  /* ---------------- rendering ---------------- */
  var elResults = $('#irh-results'), elCount = $('#irh-count'), elMore = $('#irh-more'), elActive = $('#irh-active'), elDisc = $('#irh-discover');
  function hasFilters() { return !!(S.q || S.time || S.spice || S.meal.length || S.cui.length || S.main.length || S.life.length); }

  function render() {
    var list = results();
    var focus = hasFilters() || S.mode !== 'browse';
    if (elDisc) elDisc.hidden = focus;
    $('#irh-kitchen').hidden = S.mode !== 'kitchen';
    $('#irh-spicemode').hidden = S.mode !== 'spice';
    $$('.irh-mode').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-mode') === S.mode ? 'true' : 'false'); });
    var sv = X.saved.all().length; var sb = $('[data-mode="saved"] b'); if (sb) { sb.textContent = sv; sb.hidden = !sv; }

    drawBar(); drawActive();
    if (S.mode === 'spice') drawSpices();

    /* heading + "understood as" line */
    var head = 'All recipes';
    if (S.mode === 'kitchen') head = S.have.length ? 'You can cook these' : 'Add what you have';
    else if (S.mode === 'saved') head = 'Your saved recipes';
    else if (S.spice) head = 'Recipes with this spice';
    else if (hasFilters()) head = 'Recipes for you';
    var note = '';
    if (lastSearch && lastSearch.fixed.length) note = 'Showing results for <b>' + esc(lastSearch.fixed.map(function (f) { return f[1]; }).join(', ')) + '</b>';
    elCount.innerHTML = '<div><h2>' + esc(head) + '</h2>' + (note ? '<p class="irh-understood">' + note + '</p>' : '') + '</div><p>' + list.length + (list.length === 1 ? ' recipe' : ' recipes') + '</p>';

    if (!list.length) {
      elResults.innerHTML = emptyState();
      elMore.hidden = true;
      return;
    }
    var slice = list.slice(0, S.shown);
    elResults.innerHTML = slice.map(function (r) {
      var extra = '';
      if (S.mode === 'kitchen' && r._k) {
        extra = '<div class="irh-card__have">You have ' + r._k.have + ' of ' + r._k.total +
          (r._k.missing.length ? ' · <em>need ' + esc(r._k.missing.slice(0, 3).join(', ')) + (r._k.missing.length > 3 ? '…' : '') + '</em>' : ' · <em style="color:var(--green)">ready to cook</em>') + '</div>';
      }
      return X.card(r, extra);
    }).join('');
    $$('#irh-results img').slice(0, 8).forEach(function (im) { im.loading = 'eager'; im.fetchPriority = 'high'; });
    elMore.hidden = list.length <= S.shown;
    var btn = $('button', elMore); if (btn) btn.textContent = 'Show more recipes (' + (list.length - S.shown) + ' left)';
  }

  function emptyState() {
    if (S.mode === 'kitchen' && !S.have.length) return '<div class="irh-empty"><h3>What is in your kitchen?</h3><p>Type two or three things you have, like chicken, rice or tomatoes. We will find what you can cook tonight.</p></div>';
    if (S.mode === 'saved') return '<div class="irh-empty"><h3>No saved recipes yet</h3><p>Tap the heart on any recipe to keep it here. They stay on this device.</p><button class="irh-btn" type="button" data-go-mode="browse">Browse recipes</button></div>';
    var tips = ['chicken', 'soup', 'quick pasta', 'Moroccan', 'breakfast'];
    return '<div class="irh-empty"><h3>Nothing matches yet</h3><p>Try fewer filters or a different word.</p>' +
      '<div class="irh-quick" style="justify-content:center">' + tips.map(function (t) { return '<button class="irh-chip" type="button" data-q="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') + '</div>' +
      '<p style="margin-top:16px"><button class="irh-clear" type="button" data-clear>Clear all filters</button></p></div>';
  }

  /* filter bar: one dropdown per group, with live counts */
  var GROUP_DEF = [['meal', 'Meal', X.MEAL], ['cui', 'Cuisine', X.CUI], ['main', 'Main ingredient', X.MAIN], ['time', 'Time', null], ['life', 'More', X.LIFE]];
  var openDrop = null;
  function drawBar() {
    var row = $('#irh-drops'); if (!row) return;
    row.innerHTML = GROUP_DEF.map(function (g) {
      var key = g[0], sel = key === 'time' ? (S.time ? [S.time] : []) : S[key];
      return '<div class="irh-drop" data-group="' + key + '">' +
        '<button class="irh-drop__btn' + (sel.length ? ' has-value' : '') + '" type="button" aria-expanded="' + (openDrop === key) + '">' + esc(g[1]) + (sel.length ? ' <b>' + sel.length + '</b>' : '') + '</button>' +
        (openDrop === key ? '<div class="irh-drop__panel" role="listbox" aria-label="' + esc(g[1]) + '">' + options(key, g[2]) + '</div>' : '') +
      '</div>';
    }).join('');
    var mf = $('.irh-mfilter b'); var n = S.meal.length + S.cui.length + S.main.length + S.life.length + (S.time ? 1 : 0);
    if (mf) { mf.textContent = n; mf.hidden = !n; }
    var sort = $('#irh-sort'); if (sort) sort.value = S.sort;
  }
  function options(key, list) {
    var c = counts(key);
    if (key === 'time') {
      return X.TIME.map(function (t) {
        var on = S.time === t[0];
        return '<button class="irh-opt" type="button" role="option" aria-checked="' + on + '" data-opt="time" data-val="' + t[0] + '"' + (!c[t[0]] && !on ? ' disabled' : '') + '><i></i>' + esc(t[1]) + '<span>' + (c[t[0]] || 0) + '</span></button>';
      }).join('') + '<p style="font-size:12px;color:var(--soft);padding:8px 10px 4px">Only recipes with a known cooking time.</p>';
    }
    var items = list.map(function (e) { return { k: e[0], l: e[1], n: c[e[0]] || 0 }; });
    if (key === 'cui') items.sort(function (a, b) { return b.n - a.n || a.l.localeCompare(b.l); });
    return items.map(function (it) {
      var on = S[key].indexOf(it.k) > -1;
      if (!it.n && !on) return '';
      return '<button class="irh-opt" type="button" role="option" aria-checked="' + on + '" data-opt="' + key + '" data-val="' + it.k + '"><i></i>' + esc(it.l) + '<span>' + it.n + '</span></button>';
    }).join('');
  }
  function drawActive() {
    var chips = [];
    if (S.q) chips.push(['q', '', '“' + S.q + '”']);
    ['meal', 'cui', 'main', 'life'].forEach(function (g) { S[g].forEach(function (k) { chips.push([g, k, X.labelOf(g, k)]); }); });
    if (S.time) chips.push(['time', S.time, X.labelOf('time', S.time)]);
    if (S.spice) { var sp = spiceMap()[S.spice]; chips.push(['spice', S.spice, sp ? X.shortTitle(sp.t) : 'Spice']); }
    elActive.innerHTML = chips.map(function (c) {
      return '<span class="irh-tagx">' + esc(c[2]) + '<button type="button" aria-label="Remove ' + esc(c[2]) + '" data-rm="' + c[0] + '" data-val="' + esc(c[1]) + '">×</button></span>';
    }).join('') + (chips.length ? '<button class="irh-clear" type="button" data-clear>' + (chips.length > 1 ? 'Clear all' : 'Clear') + '</button>' : '');
  }

  /* ---------------- discovery sections (shown when nothing is filtered) ---------------- */
  function drawDiscover() {
    /* hero numbers */
    var cuisines = {}; ALL.forEach(function (r) { r.cui.forEach(function (k) { cuisines[k] = 1; }); });
    var fast = ALL.filter(function (r) { return r.total != null && r.total <= 30; });
    var st = $('#irh-stats');
    if (st) st.innerHTML = '<div><b>' + ALL.length + '</b><span>recipes</span></div><div><b>' + Object.keys(cuisines).length + '</b><span>cuisines</span></div><div><b>' + fast.length + '</b><span>ready in 30 min</span></div>';

    /* fast lane */
    drawFast();
    drawWorld();
    /* meals */
    var meals = $('#irh-meals');
    if (meals) {
      meals.innerHTML = X.MEAL.map(function (e) {
        var rs = ALL.filter(function (r) { return r.meal.indexOf(e[0]) > -1; });
        if (!rs.length) return '';
        var img = (rs.filter(function (r) { return r.i; }).sort(function (a, b) { return quality(b) - quality(a); })[0] || {}).i;
        return '<button class="irh-plate" type="button" data-set="meal" data-val="' + e[0] + '"><span class="irh-plate__dish">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<b>' + esc(e[1]) + '</b><span>' + rs.length + ' recipes</span></button>';
      }).join('');
    }
    /* start with */
    var mains = $('#irh-mains');
    if (mains) {
      mains.innerHTML = X.MAIN.map(function (e) { return [e, ALL.filter(function (r) { return r.main.indexOf(e[0]) > -1; }).length]; })
        .sort(function (a, b) { return b[1] - a[1]; }).map(function (x) {
        var e = x[0], n = x[1];
        return n >= 3 ? '<button class="irh-basket__row" type="button" data-set="main" data-val="' + e[0] + '"><span>' + esc(e[1]) + '</span><i aria-hidden="true"></i><b>' + n + '</b></button>' : '';
      }).join('');
    }
    pick();
  }
  /* fast lane: 15 / 20 / 30 minute switcher (v2) */
  function drawFast() {
    var lane = $('#irh-fast'); if (!lane) return;
    var lim = S.fastLim || 30;
    var fast = ALL.filter(function (r) { return r.total != null && r.total <= lim; });
    var picks = fast.filter(function (r) { return r.i; }).sort(function (a, b) { return a.total - b.total || quality(b) - quality(a); }).slice(0, 14);
    lane.innerHTML = picks.map(function (r) { return X.card(r); }).join('');
    lane.scrollLeft = 0;
    var fl = $('#irh-fast-all'); if (fl) { fl.textContent = 'See all ' + fast.length + ' recipes in ' + lim + ' min'; fl.setAttribute('data-val', String(lim)); }
    $$('#irh-fast-tabs [data-fast]').forEach(function (b) { var on = +b.getAttribute('data-fast') === lim; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }
  function drawWorld() {
    var w = $('#irh-world'); if (!w) return;
    var tabs = $('#irh-regions');
    if (tabs) tabs.innerHTML = X.REGIONS.map(function (r) {
      var n = ALL.filter(function (x) { return r[0] === 'all' ? x.cui.length : X.CUI.some(function (e) { return e[3] === r[0] && x.cui.indexOf(e[0]) > -1; }); }).length;
      return '<button class="irh-tab' + (S.region === r[0] ? ' is-on' : '') + '" type="button" data-region="' + r[0] + '" aria-pressed="' + (S.region === r[0]) + '">' + esc(r[1]) + '<small>' + n + '</small></button>';
    }).join('');
    var tiles = X.CUI.filter(function (e) { return S.region === 'all' || e[3] === S.region; }).map(function (e) {
      var rs = ALL.filter(function (r) { return r.cui.indexOf(e[0]) > -1; });
      if (!rs.length) return '';
      var img = (rs.filter(function (r) { return r.i; })[0] || {}).i;
      return { n: rs.length, html: '<button class="irh-cui' + (img ? '' : ' no-img') + '" type="button" data-set="cui" data-val="' + e[0] + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '<b>' + esc(e[1]) + '</b><span>' + rs.length + ' recipe' + (rs.length > 1 ? 's' : '') + '</span></button>' };
    }).filter(Boolean).sort(function (a, b) { return b.n - a.n; });
    /* "All" opens with the 15 biggest kitchens; the rest are one tap away */
    var cut = S.region === 'all' && !S.worldAll && tiles.length > 15;
    w.innerHTML = (cut ? tiles.slice(0, 15) : tiles).map(function (x, i) { return i === 0 ? x.html.replace('class="irh-cui', 'class="irh-cui is-big') : x.html; }).join('');
    var more = $('#irh-world-more');
    if (more) { more.hidden = !cut; more.textContent = 'Show all ' + tiles.length + ' countries'; }
  }
  /* tonight's pick: a quick recipe with a photo, different on every visit */
  function pick() {
    var box = $('#irh-pick'); if (!box) return;
    var pool = ALL.filter(function (r) { return r.i && r.total != null && r.total <= 45 && r.ing.length; });
    if (!pool.length) pool = ALL.filter(function (r) { return r.i; });
    if (!pool.length) return;
    var r = pool[Math.floor(Math.random() * pool.length)];
    var img = $('img', box); if (img) { img.style.opacity = 0; setTimeout(function () { img.src = r.i; img.onload = function () { img.style.opacity = 1; }; }, 160); }
    $('#irh-pick-k').textContent = X.kicker(r) || 'Tonight';
    $('#irh-pick-t').textContent = r.t;
    $('#irh-pick-m').innerHTML = (r.total != null ? '<span>' + icon('clock') + ' ' + X.fmt(r.total) + '</span>' : '') + (r.ing.length ? '<span>' + r.ing.length + ' ingredients</span>' : '') + (r.x.length ? '<span>' + r.x.length + ' iSpice spices</span>' : '');
    $$('[data-pick-link]', box).forEach(function (a) { a.href = r.u; });
    box.hidden = false;
  }

  /* ---------------- cook by spice ---------------- */
  var SPICES = null;
  function spiceMap() {
    if (SPICES) return SPICES;
    SPICES = {};
    ALL.forEach(function (r) { r.x.forEach(function (p) { var s = SPICES[p.h] || (SPICES[p.h] = { h: p.h, t: p.t, i: p.i, pr: p.pr, n: 0 }); s.n++; }); });
    return SPICES;
  }
  function drawSpices() {
    var box = $('#irh-spicegrid'); if (!box) return;
    var f = X.norm(($('#irh-spiceq') || {}).value || '');
    var list = Object.keys(spiceMap()).map(function (k) { return SPICES[k]; })
      .filter(function (s) { return !f || X.norm(X.shortTitle(s.t)).indexOf(f) > -1; })
      .sort(function (a, b) { return b.n - a.n; });
    box.innerHTML = list.map(function (s) {
      return '<button class="irh-spice' + (S.spice === s.h ? ' is-on' : '') + '" type="button" data-spice="' + esc(s.h) + '">' + (s.i ? '<img src="' + esc(s.i) + '" alt="" loading="lazy">' : icon('jar')) + '<b>' + esc(X.shortTitle(s.t)) + '</b><span>' + s.n + ' recipe' + (s.n > 1 ? 's' : '') + '</span></button>';
    }).join('') || '<p style="color:var(--muted)">No spice by that name in the recipes yet.</p>';
    var head = $('#irh-spicehead'), sp = S.spice && SPICES[S.spice];
    if (head) {
      head.hidden = !sp;
      if (sp) head.innerHTML = (sp.i ? '<img src="' + esc(sp.i) + '" alt="">' : '') + '<div><b>' + esc(X.shortTitle(sp.t)) + '</b><p>Used in ' + sp.n + ' recipe' + (sp.n > 1 ? 's' : '') + (sp.pr ? ' · from ' + esc(sp.pr) : '') + ' · the recipes are just below</p></div>' +
        '<button class="irh-btn irh-btn--ghost irh-btn--sm" type="button" data-spice-change>Choose another spice</button><a class="irh-btn irh-btn--sm" href="/products/' + esc(sp.h) + '">' + icon('cart') + 'Shop this spice</a>';
    }
    /* once a spice is chosen the 65-spice grid folds away, so its recipes sit right under the choice (v2) */
    box.hidden = !!sp;
    var find = $('#irh-spiceq'); if (find && find.parentNode) find.parentNode.hidden = !!sp;
  }

  /* ---------------- search box + suggestions ---------------- */
  var input = $('#irh-q'), sug = $('#irh-suggest'), sugItems = [], sugIdx = -1, sugTimer;
  function hl(text, toks) {
    var t = esc(text);
    toks.forEach(function (w) { if (w.length > 1) t = t.replace(new RegExp('(^|\\s)(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '$1<mark>$2</mark>'); });
    return t;
  }
  function suggest() {
    var v = input.value.trim();
    if (!ALL.length) { sug.hidden = true; return; }
    var html = '', items = [];
    if (!v) {
      var recent = X.store('irh-recent') || [];
      var pop = ['Quick chicken', 'Soup', 'Italian pasta', 'Under 20 min', 'Breakfast', 'Kebab', 'Moroccan', 'Salad'];
      if (recent.length) html += group('Recent', recent.slice(0, 5).map(function (q) { items.push({ q: q }); return row(items.length - 1, icon('clock'), esc(q)); }));
      html += group('Popular searches', pop.map(function (q) { items.push({ q: q }); return row(items.length - 1, icon('search'), esc(q)); }));
    } else {
      var u = X.understand(v), toks = X.tokens(u.text || v);
      var found = X.search(ALL, u.text || v).list.filter(function (r) {
        return (!u.cui.length || u.cui.some(function (k) { return r.cui.indexOf(k) > -1; })) && (!u.meal.length || u.meal.some(function (k) { return r.meal.indexOf(k) > -1; })) && (!u.time || (r.total != null && r.total <= u.time));
      }).slice(0, 5);
      var cats = [];
      [['cui', X.CUI], ['meal', X.MEAL], ['main', X.MAIN]].forEach(function (g) {
        g[1].forEach(function (e) {
          var nl = X.norm(e[1]), nv = X.norm(v);
          if (nv.length >= 2 && (nl.indexOf(nv) === 0 || nl.split(' ').some(function (w) { return w.indexOf(nv) === 0; }))) {
            var n = ALL.filter(function (r) { return r[g[0]].indexOf(e[0]) > -1; }).length;
            if (n) cats.push({ g: g[0], k: e[0], l: e[1], n: n });
          }
        });
      });
      var sp = Object.keys(spiceMap()).map(function (k) { return SPICES[k]; }).filter(function (s) { var nt = X.norm(X.shortTitle(s.t)); return toks.length && toks.every(function (t) { return nt.indexOf(t) > -1; }); }).slice(0, 3);
      if (found.length) html += group('Recipes', found.map(function (r) { items.push({ u: r.u }); return row(items.length - 1, r.i ? '<img src="' + esc(r.i) + '" alt="" loading="lazy">' : '<span class="irh-suggest__thumb"></span>', '<div>' + hl(r.t, toks) + '<small>' + esc([X.kicker(r), r.total != null ? X.fmt(r.total) : ''].filter(Boolean).join(' · ')) + '</small></div>'); }));
      if (cats.length) html += group('Categories', cats.slice(0, 5).map(function (c) { items.push({ set: c.g, val: c.k }); return row(items.length - 1, icon(c.g === 'cui' ? 'globe' : 'pot'), esc(c.l), c.n); }));
      if (sp.length) html += group('Cook with a spice', sp.map(function (s) { items.push({ spice: s.h }); return row(items.length - 1, s.i ? '<img src="' + esc(s.i) + '" alt="" style="object-fit:contain">' : icon('jar'), esc(X.shortTitle(s.t)), s.n); }));
      items.push({ q: v });
      html += group('', [row(items.length - 1, icon('search'), 'See all results for “' + esc(v) + '”')]);
    }
    sugItems = items; sugIdx = -1;
    sug.innerHTML = html; sug.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }
  function group(label, rows) { return '<div class="irh-suggest__group" role="group">' + (label ? '<div class="irh-suggest__label">' + esc(label) + '</div>' : '') + rows.join('') + '</div>'; }
  function row(i, lead, text, count) { return '<button class="irh-suggest__item" type="button" role="option" id="irh-sg-' + i + '" data-sug="' + i + '">' + lead + '<span>' + text + '</span>' + (count ? '<span class="irh-suggest__count">' + count + '</span>' : '') + '</button>'; }
  function closeSug() { sug.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); }
  function useSug(i) {
    var it = sugItems[i]; if (!it) return;
    closeSug();
    if (it.u) { location.href = it.u; return; }
    if (it.spice) { S.mode = 'spice'; S.spice = it.spice; input.value = ''; S.q = ''; apply(true); return; }
    if (it.set) { addVal(it.set, it.val); input.value = ''; S.q = ''; apply(true); return; }
    if (it.q != null) { input.value = it.q; runSearch(true); }
  }
  /* turn the typed text into filters + words, remember it, show results */
  function runSearch(scroll) {
    var v = input.value.trim(), u = X.understand(v);
    u.cui.forEach(function (k) { addVal('cui', k); });
    u.meal.forEach(function (k) { addVal('meal', k); });
    if (u.time) S.time = String(u.time);   /* "under 20 min" means 20, not the 30 bucket */
    S.q = u.text;
    input.value = u.text;
    if (v) { var rec = (X.store('irh-recent') || []).filter(function (x) { return x !== v; }); rec.unshift(v); X.store('irh-recent', rec.slice(0, 6)); }
    if (S.mode === 'saved' || S.mode === 'spice') S.mode = 'browse';
    apply(scroll);
  }
  function addVal(g, v) { if (g === 'time') { S.time = v; return; } if (S[g].indexOf(v) < 0) S[g].push(v); }
  function apply(scroll) {
    S.shown = PAGE; writeURL(); render();
    if (scroll) {
      /* land on the library heading. The discovery chapters above have just collapsed, so a smooth scroll would
         first jump to the page end and then crawl back: go straight there when the distance is long. */
      var head = $('#irh-libhead') || $('#irh-barwrap');
      if (head) {
        var top = head.getBoundingClientRect().top + window.pageYOffset - stickyTop() - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
      }
    }
  }

  /* sticky header height, so the filter bar parks under it */
  var stickyH = null;
  function toPanel() {
    var p = $('#irh-spicemode'); if (!p) return;
    window.scrollTo({ top: Math.max(0, p.getBoundingClientRect().top + window.pageYOffset - stickyTop() - 16), behavior: 'instant' });
  }
  function stickyTop() {
    if (stickyH != null) return stickyH;
    stickyH = 0;
    var cands = document.querySelectorAll('header, .header, #header, .header-sticky-wrapper, .sticky-header, [class*="header__"]');
    for (var i = 0; i < cands.length; i++) {
      var cs = getComputedStyle(cands[i]);
      if ((cs.position === 'fixed' || cs.position === 'sticky') && cands[i].offsetHeight < 200) stickyH = Math.max(stickyH, cands[i].getBoundingClientRect().bottom);
    }
    root.style.setProperty('--irh-sticky', Math.max(0, Math.round(stickyH)) + 'px');
    return stickyH;
  }

  /* ---------------- events ---------------- */
  function bind() {
    input.addEventListener('input', function () { clearTimeout(sugTimer); sugTimer = setTimeout(suggest, 70); });
    input.addEventListener('focus', suggest);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (sug.hidden) suggest();
        e.preventDefault();
        sugIdx = Math.max(-1, Math.min(sugItems.length - 1, sugIdx + (e.key === 'ArrowDown' ? 1 : -1)));
        $$('.irh-suggest__item', sug).forEach(function (b) { b.classList.toggle('is-active', +b.getAttribute('data-sug') === sugIdx); });
        if (sugIdx > -1) input.setAttribute('aria-activedescendant', 'irh-sg-' + sugIdx);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (sugIdx > -1) useSug(sugIdx); else { closeSug(); runSearch(true); }
      } else if (e.key === 'Escape') closeSug();
    });
    $('#irh-search-form').addEventListener('submit', function (e) { e.preventDefault(); closeSug(); runSearch(true); });
    sug.addEventListener('mousedown', function (e) { e.preventDefault(); });   /* keep focus while clicking a suggestion */
    sug.addEventListener('click', function (e) { var b = e.target.closest('[data-sug]'); if (b) useSug(+b.getAttribute('data-sug')); });
    $('#irh-q-clear').addEventListener('click', function () { input.value = ''; S.q = ''; apply(); input.focus(); });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.irh-search')) closeSug();
      if (!e.target.closest('.irh-drop') && openDrop) { openDrop = null; drawBar(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openDrop) { openDrop = null; drawBar(); } });

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button,a'); if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-mode')) { S.mode = t.getAttribute('data-mode'); if (S.mode !== 'spice') S.spice = ''; apply(); if (S.mode === 'kitchen') { var hi = $('#irh-have-in'); if (hi) hi.focus(); } return; }
      if (t.hasAttribute('data-go-mode')) { S.mode = t.getAttribute('data-go-mode'); apply(); return; }
      if (t.classList.contains('irh-drop__btn')) { var g = t.parentNode.getAttribute('data-group'); openDrop = openDrop === g ? null : g; drawBar(); return; }
      if (t.hasAttribute('data-opt')) {
        var grp = t.getAttribute('data-opt'), val = t.getAttribute('data-val');
        if (grp === 'time') S.time = S.time === val ? '' : val;
        else { var i = S[grp].indexOf(val); if (i > -1) S[grp].splice(i, 1); else S[grp].push(val); }
        S.shown = PAGE; writeURL(); render(); return;
      }
      if (t.hasAttribute('data-rm')) {
        var rg = t.getAttribute('data-rm'), rv = t.getAttribute('data-val');
        if (rg === 'q') { S.q = ''; input.value = ''; } else if (rg === 'time') S.time = ''; else if (rg === 'spice') S.spice = '';
        else S[rg] = S[rg].filter(function (x) { return x !== rv; });
        apply(); return;
      }
      if (t.hasAttribute('data-clear')) { S.q = ''; input.value = ''; S.meal = []; S.cui = []; S.main = []; S.life = []; S.time = ''; S.spice = ''; if (S.mode === 'spice') S.mode = 'browse'; apply(); return; }
      if (t.hasAttribute('data-set')) { addVal(t.getAttribute('data-set'), t.getAttribute('data-val')); apply(true); return; }
      if (t.hasAttribute('data-q')) { input.value = t.getAttribute('data-q'); runSearch(true); return; }
      if (t.hasAttribute('data-fast')) { S.fastLim = +t.getAttribute('data-fast'); drawFast(); return; }
      if (t.hasAttribute('data-region')) { S.region = t.getAttribute('data-region'); drawWorld(); return; }
      if (t.id === 'irh-world-more') { S.worldAll = true; drawWorld(); return; }
      if (t.hasAttribute('data-spice')) { var h = t.getAttribute('data-spice'); S.spice = S.spice === h ? '' : h; apply(); toPanel(); return; }
      if (t.hasAttribute('data-spice-change')) { S.spice = ''; apply(); toPanel(); return; }
      if (t.hasAttribute('data-have-idea')) { t.getAttribute('data-have-idea').split(',').forEach(function (x) { x = x.trim(); if (x && S.have.indexOf(x) < 0) S.have.push(x); }); drawHave(); apply(); return; }
      if (t.hasAttribute('data-have-rm')) { var hv = t.getAttribute('data-have-rm'); S.have = S.have.filter(function (x) { return x !== hv; }); drawHave(); apply(); return; }
      if (t.id === 'irh-another') { pick(); return; }
      if (t.id === 'irh-surprise') {
        var l = results(); if (!l.length) l = ALL;
        var r = l[Math.floor(Math.random() * l.length)]; if (r) location.href = r.u; return;
      }
      if (t.classList.contains('irh-mfilter')) { var bar = $('.irh-bar'); bar.classList.toggle('is-sheet'); return; }
      if (t.hasAttribute('data-sheet-close')) { $('.irh-bar').classList.remove('is-sheet'); return; }
    });
    $('#irh-sort').addEventListener('change', function (e) { S.sort = e.target.value; apply(); });
    $('#irh-more button').addEventListener('click', function () { S.shown += PAGE; render(); });
    /* keep loading as you reach the end (the button stays for keyboards) */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { if (en[0].isIntersecting && !elMore.hidden) { S.shown += PAGE; render(); } }, { rootMargin: '600px' }).observe(elMore);
    }
    /* kitchen input */
    var hin = $('#irh-have-in');
    if (hin) {
      hin.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ',') && hin.value.trim()) {
          e.preventDefault();
          hin.value.split(',').forEach(function (x) { x = x.trim().toLowerCase(); if (x && S.have.indexOf(x) < 0) S.have.push(x); });
          hin.value = ''; drawHave(); apply();
        } else if (e.key === 'Backspace' && !hin.value && S.have.length) { S.have.pop(); drawHave(); apply(); }
      });
      var st = $('#irh-staples'); if (st) st.addEventListener('change', function () { S.staples = st.checked; render(); });
    }
    var sq = $('#irh-spiceq'); if (sq) sq.addEventListener('input', drawSpices);
    document.addEventListener('irh:saved', function () { if (S.mode === 'saved') render(); else { var sb = $('[data-mode="saved"] b'); var n = X.saved.all().length; if (sb) { sb.textContent = n; sb.hidden = !n; } } });
    window.addEventListener('scroll', function once() { stickyTop(); window.removeEventListener('scroll', once); }, { passive: true });
  }
  function drawHave() {
    var box = $('#irh-have-chips'); if (!box) return;
    box.innerHTML = S.have.map(function (h) { return '<span class="irh-tagx">' + esc(h) + '<button type="button" aria-label="Remove ' + esc(h) + '" data-have-rm="' + esc(h) + '">×</button></span>'; }).join('');
  }

  /* ---------------- start ---------------- */
  readURL();
  if (S.q) input.value = S.q;
  X.load(FEED).then(function (list) {
    ALL = list; list.forEach(function (r) { BY[r.h] = r; });
    root.classList.add('is-live');
    var ssr = $('#irh-ssr'); if (ssr) ssr.hidden = true;
    $('#irh-live').hidden = false;
    drawDiscover(); drawHave(); bind(); render();
    stickyTop();
  }).catch(function (e) {
    console.warn('irh: recipe feed did not load, keeping the page list', e);
  });
})();
